import { render, staticRenderFns } from "./Diametro.vue?vue&type=template&id=6baf2088"
import script from "./Diametro.vue?vue&type=script&lang=ts"
export * from "./Diametro.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports